import ROUTE from 'constant/route'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { useAppSelector } from 'store/useStoreHook'
import useSubdomain from 'hooks/useSubdomain/useSubdomain'
import { AuthorizationState } from 'store/models/authModels'
import SplashPage from 'pages/SplashPage'

function ClientRoute(props: RouteProps) {
    const authState = useAppSelector((state) => state.auth.authState)
    const { hasSubDomain } = useSubdomain()

    if (!hasSubDomain) return <Redirect to={ROUTE.REGISTER} />

    if (authState === AuthorizationState.SUCCESS_REAL_CLIENT)
        return <Route {...props} />
    else if (authState === AuthorizationState.SUCCESS_NON_CLIENT)
        return <Redirect to={ROUTE.SELECT_DEVICE} />
    else if (
        authState === AuthorizationState.PREPARE ||
        authState === AuthorizationState.PROCESSING
    )
        return <SplashPage />
    // Auth Error
    else return <Redirect to={ROUTE.LOGIN} />
}

export default ClientRoute
